























import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { groupCompareSynthEZDistributeScoreType } from '@/api/teachingProtection/assessment'
import BarHorizontal from '../../../_components/charts/BarHorizontal.vue'
import BasePanel from '@/components/BasePanel/index.vue'

  @Component({
    components: {
      BarHorizontal,
      BasePanel
    }
  })
export default class extends Vue {
    @Prop({ default: '' }) private title!: string
    private list: any = []
    private types: any = {
      dpaEnergyZoneType: '',
      resultTypeCode: 101
    }

    created() {
      this.update()
    }
    update() {
      if (!this.$route.query.searchParams) return
      let params = JSON.parse(this.$route.query.searchParams as string)
      console.info(this.types, 6666)
      groupCompareSynthEZDistributeScoreType({ ...params, ...this.types }).then(res => {
        this.list = res.data.barChart || []
      })
    }
}
